import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './CardHeader.module.css';
export enum HorizontalAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
export type CardHeaderProps = PropsWithChildren<{
  textAlignment?: HorizontalAlignment;
}>;
export const CardHeader: FunctionComponent<CardHeaderProps> = React.memo(props => {
  const $ = _c(12);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let remainingProps;
  let t1;
  if ($[2] !== t0) {
    ({
      textAlignment: t1,
      children,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = remainingProps;
    $[5] = t1;
  } else {
    children = $[3];
    remainingProps = $[4];
    t1 = $[5];
  }
  const textAlignment = t1 === undefined ? HorizontalAlignment.Left : t1;
  const t2 = textAlignmentToClassName[textAlignment];
  let t3;
  if ($[6] !== t2) {
    t3 = classes(styles.header, t2);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== remainingProps || $[10] !== t3) {
    t4 = <header {...remainingProps} className={t3}>{children}</header>;
    $[8] = children;
    $[9] = remainingProps;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
});
const textAlignmentToClassName: Record<HorizontalAlignment, string | null> = {
  left: styles.alignLeft,
  center: styles.alignCenter,
  right: styles.alignRight
};